import React, { useState } from "react";
import { BsPersonFillCheck } from "react-icons/bs";
import { FaHandshakeSimple } from "react-icons/fa6";
import { FcPositiveDynamic } from "react-icons/fc";

const Values = () => {
  const [values, setValues] = useState([
    {
      id: 1,
      title: "Integrity",
      logo: <BsPersonFillCheck />,
    },
    {
      id: 2,
      title: "Trust",
      logo: <FaHandshakeSimple />,
    },
    {
      id: 3,
      title: "Positive Results",
      logo: <FcPositiveDynamic />,
    },
  ]);
  return (
    <section className="container mx-auto mt-10 px-4">
      <div className="flex flex-col space-y-10">
        <p className="text-2xl font-semibold opacity-80 sm:text-3xl text-black">
          Our Values
        </p>
        <div className="flex justify-between items-center flex-wrap gap-10">
          {values.map((value) => (
            <>
              <div className="space-y-2">
                <div className="h-36 w-36 flex justify-center items-center rounded-full border-8 border-black border-opacity-60">
                  <p className="text-6xl text-black opacity-70">{value.logo}</p>
                </div>
                <p className=" text-center font-medium">{value.title}</p>
              </div>
            </>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Values;
